import { useLang } from '../lang'
import type { Today } from '../types'
import { Sparkline } from './Sparkline'
import { WindowPicker } from './WindowPicker'
import * as ts from './todayspark.css'

// The activity sparkline as its own quiet band in the day strip — the single live gesture. The
// time-window control sits in its head; the ticks below rescale to the chosen span.
export function TodaySpark({
  today,
  windows,
  value,
  onChange,
}: {
  today: Today
  windows: [string, number][]
  value: number
  onChange: (hours: number) => void
}) {
  const { lang } = useLang()
  if (!today?.sparkline) return null

  const pick = (a: { en: string; ga: string }) => (lang === 'ga' ? a.ga : a.en)
  // Keep the extreme ticks inside the edges; centre the rest on their mark.
  const shift = (x: number) => (x <= 0 ? '0' : x >= 1 ? '-100%' : '-50%')

  return (
    <section className={ts.band}>
      <div className={ts.head}>
        <WindowPicker windows={windows} value={value} onChange={onChange} />
      </div>
      <Sparkline paths={today.sparkline} />
      <div className={ts.anchors}>
        {today.anchors.map((a, i) => (
          <span key={i} style={{ left: `${a.x * 100}%`, transform: `translateX(${shift(a.x)})` }}>
            {pick(a)}
          </span>
        ))}
      </div>
    </section>
  )
}
